export default "__VITE_ASSET__CJPQqLxn__"